var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Suggestions", {
        attrs: { suggestions: _vm.suggestions, colors: _vm.colors },
        on: { sendSuggestion: _vm._submitSuggestion }
      }),
      _vm._v(" "),
      _vm.file
        ? _c(
            "div",
            {
              staticClass: "file-container",
              style: {
                backgroundColor: _vm.colors.userInput.text,
                color: _vm.colors.userInput.bg
              }
            },
            [
              _c("span", { staticClass: "icon-file-message" }, [
                _c("img", {
                  attrs: {
                    src: _vm.icons.file.img,
                    alt: _vm.icons.file.name,
                    height: "15"
                  }
                })
              ]),
              _vm._v("\n    " + _vm._s(_vm.file.name) + "\n    "),
              _c(
                "span",
                {
                  staticClass: "delete-file-message",
                  on: {
                    click: function($event) {
                      return _vm.cancelFile()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.icons.closeSvg.img,
                      alt: _vm.icons.closeSvg.name,
                      height: "10",
                      title: "Remove the file"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "sc-user-input",
          class: { active: _vm.inputActive },
          style: { background: _vm.colors.userInput.bg }
        },
        [
          _c("div", {
            ref: "userInput",
            staticClass: "sc-user-input--text",
            style: { color: _vm.colors.userInput.text },
            attrs: {
              role: "button",
              tabIndex: "0",
              contentEditable: "true",
              placeholder: _vm.placeholder
            },
            on: {
              focus: function($event) {
                return _vm.setInputActive(true)
              },
              blur: function($event) {
                return _vm.setInputActive(false)
              },
              keydown: _vm.handleKey,
              focusUserInput: function($event) {
                return _vm.focusUserInput()
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "sc-user-input--buttons" }, [
            _c("div", { staticClass: "sc-user-input--button" }),
            _vm._v(" "),
            _vm.showEmoji && !_vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "sc-user-input--button" },
                  [
                    _c("EmojiIcon", {
                      attrs: {
                        onEmojiPicked: _vm._handleEmojiPicked,
                        color: _vm.colors.userInput.text
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showFile && !_vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "sc-user-input--button" },
                  [
                    _c("FileIcons", {
                      attrs: {
                        onChange: _vm._handleFileSubmit,
                        color: _vm.colors.userInput.text
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "sc-user-input--button" },
                  [
                    _c(
                      "user-input-button",
                      {
                        attrs: {
                          color: _vm.colors.userInput.text,
                          tooltip: "cancel"
                        },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm._editFinish.apply(null, arguments)
                          }
                        }
                      },
                      [_c("icon-cross")],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sc-user-input--button" },
              [
                _vm.isEditing
                  ? _c(
                      "user-input-button",
                      {
                        attrs: {
                          color: _vm.colors.userInput.text,
                          tooltip: "Edit"
                        },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm._editText.apply(null, arguments)
                          }
                        }
                      },
                      [_c("icon-ok")],
                      1
                    )
                  : _c(
                      "user-input-button",
                      {
                        attrs: {
                          color: _vm.colors.userInput.text,
                          tooltip: "Send"
                        },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm._submitText.apply(null, arguments)
                          }
                        }
                      },
                      [_c("icon-send")],
                      1
                    )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06850670", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06850670","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-beautiful-chat/src/UserInput.vue
// module id = 1998
// module chunks = 120